import React from 'react';
import FileUploadField from '../../../components/Fields/FileUploadField';
import { FieldProps } from '../../../components/Fields/Types';
import WorkflowTaskAddMultipleDocumentsModel from '../../../models/WorkflowTaskAddMultipleDocumentsModel';

interface IProps {
    formData: WorkflowTaskAddMultipleDocumentsModel
    getFieldProps: (fieldName: string) => FieldProps

}
const TaskAddMultipleDocumentsView: React.FC<IProps> = ({ formData, getFieldProps }) => {
    console.log('formData', formData)
    return (<>
        {formData.documents.map((document, index) => {
            const allowMultiple = document.attachmentType.maxAttachments !== 1;

            return <FileUploadField key={index} {...getFieldProps(`workflowTaskAddMultipleDocumentsModel.documents.${index}.document`)} multiple={allowMultiple} />
        })}
    </>)
}
export default TaskAddMultipleDocumentsView;